import { render, staticRenderFns } from "./GMovableLayoutBoxEx.vue?vue&type=template&id=fa5a8b52&scoped=true&"
import script from "./GMovableLayoutBoxEx.vue?vue&type=script&lang=ts&"
export * from "./GMovableLayoutBoxEx.vue?vue&type=script&lang=ts&"
import style0 from "./GMovableLayoutBoxEx.vue?vue&type=style&index=0&id=fa5a8b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5a8b52",
  null
  
)

export default component.exports